import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Label, InputText, InputTextarea, ErrorMessage } from '@teo/components';

export const BasicSettings = ({
  learningpath,
  setGlobalState,
  globalState,
  checkValid,
}: any) => {
  const { t } = useTranslation();

  const [lpName, setLpName] = useState(
    globalState?.name
      ? globalState?.name
      : learningpath?.lpName
      ? learningpath?.lpName
      : ''
  );
  const [lpDescription, setLpDescription] = useState(
    globalState?.description
      ? globalState?.description
      : learningpath?.lpDescription
      ? learningpath?.lpDescription
      : ''
  );

  const handleError = (el: string) => (el ? false : checkValid ? true : false);

  useEffect(() => {
    setGlobalState((prev: any) => ({
      ...prev,
      name: lpName,
      description: lpDescription,
    }));
  }, [lpName, lpDescription]);

  return (
    <div className="flex flex-col">
      <div className="mb-2">
        <h3 className="mb-2 text-base">
          {t('pages.learning_path.publish.basic_settings_heading')}
        </h3>
        <p className='"pt-3 text-sm text-grey-07'>
          {t('pages.learning_path.publish.basic_settings_text')}
        </p>
      </div>
      <div className="flex h-full flex-col md:w-full">
        <div className="mb-2">
          <Label htmlFor="lpTitle">
            <p className="mt-6 text-sm font-semibold">
              {t('pages.learning_path.publish.basic_settings_name')}
            </p>
          </Label>
          <InputText
            id="lpTitle"
            type="text"
            onChange={(event) => setLpName(event.currentTarget.value)}
            value={lpName}
            hasError={handleError(lpName)}
          />
          {handleError(lpName) && (
            <div className="mt-0 mb-2 text-sm text-tint-red-dark">
              <ErrorMessage id="errorMessage">
                {t('pages.create_edit_course.course_title_error')}
              </ErrorMessage>
            </div>
          )}
        </div>

        <div>
          <Label htmlFor="lpDescription">
            <p className="mt-6 text-sm font-semibold">
              {t('pages.learning_path.publish.basic_settings_description')}
            </p>
          </Label>

          <InputTextarea
            id="lpDescription"
            placeholder={t(
              'pages.learning_path.publish.description_placeholder'
            )}
            onChange={(event) => setLpDescription(event.currentTarget.value)}
            limit={300}
            value={lpDescription}
            hasError={handleError(lpDescription)}
          />

          {handleError(lpDescription) && (
            <div className="mt-0 mb-2 text-sm text-tint-red-dark">
              <ErrorMessage id="errorMessage">
                {t('pages.create_edit_course.course_description_error')}
              </ErrorMessage>
            </div>
          )}
        </div>
      </div>
      <div></div>
    </div>
  );
};
